/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export class SysqueSizeRangeVM {
    title?: string;
    columnAutoWidth?: boolean = true;
    columnHidingEnabled?: boolean = true;
    allowColumnResizing?: boolean = true;
    columnResizingMode?: string = 'widget';
    columnMinWidth?: number = 30;
    showColumnLines?: boolean = false;
    showRowLines?: boolean = false;
    rowAlternationEnabled?: boolean = true;
    selection?: SysqueSelectionVM ={
        mode: 'multiple',
        showCheckBoxesMode: 'always'
      };
    sizeRangeItems?: SysqueSizeRangeItemsVM[];
    height?: string = '100%';
}
export interface SysqueSizeRangeItemsVM {
    id: number;
    isChecked?: number;
    [key: string]: number;
    
}

export interface ColumnsData {
    dataField: string;
    caption: string;
}

export interface SysqueSelectionVM {
    allowSelectAll?: boolean;
    deferred?: boolean;
    mode?: string;
    selectAllMode?: string;
    showCheckBoxesMode?: string;
}

export function convertSysqueSizeRangeVMToColumns(sizeRangeItems: SysqueSizeRangeItemsVM[]): ColumnsData[] {
    const columns: ColumnsData[] = [];
        // Iterate over the keys of each data object
        Object.keys(sizeRangeItems[0]).forEach(key => {
            if (!key.toLowerCase().startsWith('id') && !key.toLowerCase().startsWith('ischecked')) {
                columns.push({ dataField: key, caption: `${key.charAt(0).toUpperCase()}${key.slice(1)}` });
            }
        });
    return columns;
}

export function getSysqueSizeRangeVMByColumnMinValue(sizeRangeItems: SysqueSizeRangeItemsVM[], value: number): SysqueSizeRangeItemsVM[] {
    return sizeRangeItems.filter(row => {
        const firstColumnName = Object.keys(row)[2];
        return row[firstColumnName] >= value;
    });
}

export function getSysqueSizeRangeVMByColumnMaxValue(sizeRangeItems: SysqueSizeRangeItemsVM[], value: number): SysqueSizeRangeItemsVM[] {
    return sizeRangeItems.filter(row => {
        const firstColumnName = Object.keys(row)[2];
        return row[firstColumnName] <= value;
    });
}